<template>
	<div>
		<div class="videoInfo">
			
			<img src="@/static/images/icon-arrowLeft.png" class="goback" @click="goBack">
			<div class="video-box">
				<video class="video" :src="video+'?fops=avthumb/m3u8/noDomain/1/vb/500k/t/10'" autoplay="autoplay" controls x-webkit-airplay="allow" x5-playsinline="" webkit-playsinline="" playsinline="true" >
					您的浏览器不支持 HTML5 video 标签。
				</video>
			</div>
			
			<div class="info">
				<div class="line" v-if="naming">《{{naming}}》</div>
				<div class="line" v-if="play">演奏：{{play}}</div>
				<div class="line" v-if="type == 0 && accompaniment">伴奏：{{accompaniment}}</div>
				<div class="line" v-if="type == 1 && accompaniment">指导老师：{{accompaniment}}</div>
			</div>
			
		</div>
		
		
	</div>
</template>

<script>
	/* eslint-disable */
	export default {
		watch: {
		},
		data() {
			return{
				type: '',
				video: '',
				naming: '',
				play: '',
				accompaniment: ''
			}
		},
		created() {

		},
		mounted() {
			if (this.$route.query.id) {
				this.getData()
			} else {
				this.video = this.$route.query.src
			}
			this.type = this.$route.query.type
			this.$wx.ready(() => {
				this.$wx.updateAppMessageShareData({
					title: '福建省民族管弦乐学会',
					desc: '福建省民族管弦乐学会',
					link: location.href,
					imgUrl: 'http://guan.xuanyue.zaihukeji.cn/uploads/wx_share.png'
				})
				this.$wx.updateTimelineShareData({
					title: '福建省民族管弦乐学会',
					link: location.href,
					imgUrl: 'http://guan.xuanyue.zaihukeji.cn/uploads/wx_share.png'
				})
			});
		},
		methods: {
			goBack() {
				if (window.history.length <=1 ) {
					this.$router.push('/home')
				} else {
					this.$router.back(-1)
				}
			},
			getData() {
				this.$get('api/actile/getVideoDetails', {
					article_id: this.$route.query.id
				}).then(res => {
					let result = res.data
					this.video = result.video
					this.naming = result.naming
					this.play = result.play
					this.accompaniment = result.accompaniment
				})
			}
		}
	}
</script>

<style scoped lang="stylus">
.videoInfo
	width 100vw
	height 100vh
	position relative
	background #000
	overflow hidden
	.goback
		position absolute
		z-index 1000
		left 30px
		top 30px
		width 52px
		height 52px
	.video-box
		position absolute
		top 50%
		transform translateY(-50%)
		left 0
		width 100%
	.video
		width 100%
		object-fit fill
	.info
		position absolute
		left 30px
		bottom 140px
		font-size: 26px;
		color: #FFFFFF;
		z-index 1000
		.line
			margin-bottom 12px
</style>
